import styled from 'styled-components';

export default styled.div`
  margin: 18px 0 36px 0;
`;
